import { useEffect, useState } from 'react';
import { PROPERTY_REFRESH_EVENT } from './propertyRefreshEvent';
import { fetchResponseAdapter } from '../../../adapters/fetchAdapter';
import useAuth from '../../../hooks/useAuth';
import useCallApiAndLoad from '../../../hooks/useCallApiAndLoad';
import { getPropertyToEditEndpoint } from '../services/propertyService';
import { PropertyUpdateDataApi } from '../models/propertyModel';

interface Props {
  propertyId: string;
}
const useAdminRent = ({ propertyId }: Props) => {
  const { getAuthToken } = useAuth();
  const token = getAuthToken();
  const { callEndpoint } = useCallApiAndLoad();
  const [formUpdateData, setFormUpdateData] = useState<PropertyUpdateDataApi>();

  const loadPropertyToUpdate = async (propertyId: string) => {
    const { status, data } = await callEndpoint(
      getPropertyToEditEndpoint(propertyId, token),
    );
    if (status === 200) {
      const { data: formData } = fetchResponseAdapter(data);
      setFormUpdateData(formData);
    }
  };

  useEffect(() => {
    const reload = () => loadPropertyToUpdate(propertyId).catch((e) => console.error(e));
    reload();
    window.addEventListener(PROPERTY_REFRESH_EVENT, reload);
    return () => window.removeEventListener(PROPERTY_REFRESH_EVENT, reload);
  }, []);

  return { formUpdateData };
};

export default useAdminRent;
